'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.launcherClosedDark = exports.initialMessageBubbleTail = exports.defaultNotificationAvatar = exports.signupMock3 = exports.launcherClosed = exports.launcherOpen = exports.launcherOpenDark = exports.greenThumbtack = exports.welcomeIcon = exports.previewMobile = exports.previewTablet = exports.previewDesktop = exports.embedCodeEmail = exports.embedCodeCopy = exports.adminChatWhispey = exports.chatZeroState = exports.indexZeroState = undefined;

var _getStaticAssetUrl = require('conversations-lib/urls/getStaticAssetUrl');

var _getStaticAssetUrl2 = _interopRequireDefault(_getStaticAssetUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCoreImageUrl = _getStaticAssetUrl2.default.bind(null, 'conversations-core/static-1.139/img');

var indexZeroState = exports.indexZeroState = getCoreImageUrl('zero-state-icon.svg');

var chatZeroState = exports.chatZeroState = getCoreImageUrl('messages-zero-state.svg');

var adminChatWhispey = exports.adminChatWhispey = getCoreImageUrl('chat-whispey-admin.svg');

var embedCodeCopy = exports.embedCodeCopy = getCoreImageUrl('embed-code-copy.svg');

var embedCodeEmail = exports.embedCodeEmail = getCoreImageUrl('embed-code-email.svg');

var previewDesktop = exports.previewDesktop = getCoreImageUrl('preview-desktop.svg');

var previewTablet = exports.previewTablet = getCoreImageUrl('preview-tablet.svg');

var previewMobile = exports.previewMobile = getCoreImageUrl('preview-mobile.svg');

var welcomeIcon = exports.welcomeIcon = getCoreImageUrl('welcome-prompt-icon.svg');

var greenThumbtack = exports.greenThumbtack = getCoreImageUrl('green-thumbtack.svg');

var launcherOpenDark = exports.launcherOpenDark = getCoreImageUrl('launcher-open-icon-dark.svg');

var launcherOpen = exports.launcherOpen = getCoreImageUrl('launcher-open-icon.svg');

var launcherClosed = exports.launcherClosed = getCoreImageUrl('launcher-close-icon.svg');

var signupMock3 = exports.signupMock3 = getCoreImageUrl('sign-up-preview-image-3.png');

var defaultNotificationAvatar = exports.defaultNotificationAvatar = getCoreImageUrl('push-notification-icon.png');

var initialMessageBubbleTail = exports.initialMessageBubbleTail = getCoreImageUrl('initialMessageBubbleTail.svg');

var launcherClosedDark = exports.launcherClosedDark = getCoreImageUrl('launcher-close-icon-dark.svg');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/images.js
// module id = 116
// module chunks = 0 1